import { axiosInstance } from "./AxiosDefaults";
import { productCategoriesRoute } from "../constants/ApiRoutes";
import { ProductCategory } from "../models/Product";

export type ApiResponse<T> = {
  status?: "SUCCESS" | "ERROR";
  message?: string;
  result?: T;
};

export const getAllProductCategories = (): Promise<any> => {
  return axiosInstance.get(productCategoriesRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createProductCategory = (
  payload: Partial<ProductCategory>
): Promise<any> => {
  return axiosInstance.post(productCategoriesRoute, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateOneProductCategory = (
  id: number,
  payload: Partial<ProductCategory>
): Promise<any> => {
  return axiosInstance.put(`${productCategoriesRoute}/${id}`, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};
